export const getPopupState = state => {
  return state.Feedback.popup;
};
